import script from "./numberIntegration.vue?vue&type=script&setup=true&lang=js"
export * from "./numberIntegration.vue?vue&type=script&setup=true&lang=js"

import "./numberIntegration.vue?vue&type=style&index=0&id=95d7e192&lang=css"

const __exports__ = script;

export default __exports__